<template>
  <div class="col-lg-4 py-sm px-1">
    <card shadow class="border-0 h-100 p-0 m-0 bg-display-panel-card">
      <div class="h5 text-white">{{ title }}</div>
      <div class="py-sm">
        <div class="bg-display-panel-card-2 rounded-circle mx-auto">
          <img v-if="icon.length" class="m-4" :src="'/icons/'+icon+'.png'">
        </div>
      </div>
      <p class="text-white">{{ text }}</p>
    </card>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "dark"
    }
  }
};
</script>
<style scoped>
.bg-display-panel-card {
  background: rgba(255, 255, 255, 0.1);
}
.bg-display-panel-card-2 {
  background-image: radial-gradient(
    circle farthest-corner at 48.8% 52%,
    rgba(15, 13, 58, 1) 0.1%,
    rgba(10, 14, 42, 1) 100.2%
  );

  /* background: rgba(255, 255, 255, 0.3); */
  width: 144px;
  height: 144px;
}
</style>

